import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UserOrganizationPolicyDto } from '../../commonTypes/acs/user.types';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';
import { LeaveRequestType } from '../../commonTypes/leaveRequest.types';

export interface UserOrganizationPolicies {
    value: UserOrganizationPolicyDto[];
}

const initialState: UserOrganizationPolicies = {
    value: [],
};

const userOrganizationPoliciesSlice = createSlice({
    name: 'userOrganizationPolicies',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        addUserOrganizationPolicies: (state, action: PayloadAction<UserOrganizationPolicyDto[]>) => {
            action.payload.forEach((policy, index) => {
                if (policy.leaveType.toLowerCase() === LeaveRequestType.VACATION.toLowerCase()) {
                    action.payload.splice(index, 1);
                    action.payload.unshift(policy);
                }
            });
            state.value = action.payload;
        },
    },
});

export const { addUserOrganizationPolicies } = userOrganizationPoliciesSlice.actions;

export const selectUserOrganizationPolicies = (state: RootState) => state.userOrganizationPolicies.value;

export default userOrganizationPoliciesSlice.reducer;
